import { t } from "@travily/i18n";
import { ConfirmDialog } from "@ui/components/ConfirmDialog";

export interface UnsavedChangesDialogProps {
  isOpen: boolean;
  /** Confirm — abandon the pending changes and continue the intercepted navigation. */
  onConfirm: () => void;
  onOpenChange: (isOpen: boolean) => void;
}

/**
 * Asks before a navigation that would drop unsaved edits. Every dismissal path
 * (Escape, the close X, the cancel button) means "keep editing", so the confirm
 * action is the one that leaves.
 */
export function UnsavedChangesDialog({ isOpen, onConfirm, onOpenChange }: UnsavedChangesDialogProps) {
  return (
    <ConfirmDialog
      cancelLabel={t("components.views.shared.unsaved_changes_dialog.stay")}
      confirmLabel={t("components.views.shared.unsaved_changes_dialog.leave")}
      description={t("components.views.shared.unsaved_changes_dialog.body")}
      illustration="delete-confirmation"
      isOpen={isOpen}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      title={t("components.views.shared.unsaved_changes_dialog.title")}
      tone="danger"
    />
  );
}
